import { httpService } from '@/api/v1/http.service'

import type { CurriculumAim } from '../constants/curriculum-aim'

export const validateNameUniqueness = async ({
  curriculumId,
  educationLevel,
  name,
  aim
}: {
  curriculumId?: string
  educationLevel: string
  name: string
  aim: CurriculumAim
}) => {
  const response = await httpService.panel.panelCurriculumsCheckNameTakenCreate(
    {
      education_level: educationLevel,
      name,
      aim,
      excluded_curriculum: curriculumId
    }
  )

  return !response.is_taken
}
